import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { Field } from 'react-final-form';

import { SurveyCreator, SurveyCreatorComponent } from 'survey-creator-react';
import {
  applyBrandSettings,
  CUSTOM_DEFAULT_BRAND_COLOR,
  CUSTOM_DEFAULT_FONT,
  CUSTOM_OPTIONS_SURVEY,
} from '../../containers/change-insights/utils/index.jsx';
import DatePickerAdapter from '../DatePickerAdapter.jsx';

const ChangeInsightsEditForm = ({
  data,
  values,
  loading,
  errorsFields,
  handleSubmit,
  handlePreview,
  onCancel,
  creator,
  setCreator,
}) => {
  const handleClick = () => {
    handleSubmit(values);
  };

  useEffect(() => {
    const creatorNew = new SurveyCreator(CUSTOM_OPTIONS_SURVEY);
    if (data) {
      creatorNew.JSON = data;
    }
    creatorNew.onNotify.add(() => {});
    setCreator(creatorNew);
  }, [data]);

  useEffect(() => {
    applyBrandSettings({
      brandColor: CUSTOM_DEFAULT_BRAND_COLOR,
      fontName: CUSTOM_DEFAULT_FONT,
    });
  }, []);

  useEffect(() => {
    // TODO: remove after update next/react version, code need for correctly drag element question inside block
    const handleMouseMove = (event) => {
      const { body } = document;
      const nextDiv = body.nextElementSibling;
      const mouseX = event.clientX + window.scrollX;
      const mouseY = event.clientY + window.scrollY;

      if (nextDiv?.tagName === 'DIV') {
        nextDiv.style.top = `${mouseY}px`;
        nextDiv.style.left = `${mouseX}px`;
        nextDiv.style.minHeight = '40px';
      }
    };

    document.addEventListener('mousemove', handleMouseMove);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <React.Fragment>
      <div className="m-b-60" id="surveyCreatorContainer">
        {creator ? <SurveyCreatorComponent creator={creator} /> : null}
      </div>
      <div style={{ padding: '0 84px' }}>
        <h4 className="text-muted m-b-24">Feedback Settings</h4>
        <div
          className="flex select-survey-date-form"
          style={{ gap: '24px', alignItems: 'flex-start' }}
        >
          <Field
            id="surveyFormStartDate"
            name="startDate"
            label="Start Date"
            placeholderText="Start Date"
            dateFormat="MM/DD/YYYY"
            isClearable={values.startDate}
            component={DatePickerAdapter}
          />

          <Field
            id="surveyFormEndDate"
            name="endDate"
            label="End Date"
            placeholderText="End Date"
            dateFormat="MM/DD/YYYY"
            isClearable={values.endDate}
            component={DatePickerAdapter}
          />
        </div>
      </div>

      <div style={{ padding: '24px 84px' }}>
        <div>
          {errorsFields?.message ? (
            <p className="text-danger">{errorsFields.message}</p>
          ) : null}
        </div>
        <div>
          <div>
            <div className="flex" style={{ justifyContent: 'space-between' }}>
              <div>
                <Button onClick={onCancel} bsStyle="default">
                  Cancel
                </Button>
                <Button
                  className="m-l-12"
                  bsStyle="primary"
                  disabled={loading}
                  onClick={handleClick}
                >
                  {loading ? 'Saving...' : 'Save'}
                </Button>
              </div>
              <div>
                <Button
                  bsStyle="success"
                  className="add-activity-button"
                  onClick={() => handlePreview(creator.JSON)}
                >
                  Preview in New Tab
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ChangeInsightsEditForm;
